import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const MedicionCaudalMasicoSchema = yup.object().shape({
  contaminante: yup
    .object()
    .required("errors.medicionCaudalMasico.contaminante.required")
    .default(null),
  cantidad: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.medicionCaudalMasico.cantidad.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "MGS" } }),
});
